import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e068e92"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = { class: "list-group" }
const _hoisted_3 = { class: "list-group-item" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Type", -1))
const _hoisted_5 = { class: "list-group-item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Reason", -1))
const _hoisted_7 = { class: "list-group-item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Source Of Funding", -1))
const _hoisted_9 = { class: "list-group-item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Process", -1))
const _hoisted_11 = { class: "list-group-item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Next Steps", -1))
const _hoisted_13 = { class: "list-group-item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Bid Intent", -1))
const _hoisted_15 = { class: "list-group-item" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Confidential", -1))
const _hoisted_17 = { class: "list-group-item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Conflict of Interest", -1))
const _hoisted_19 = { class: "list-group-item" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Conflict of Interest", -1))
const _hoisted_21 = { class: "list-group-item" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Resources Available", -1))
const _hoisted_23 = { class: "list-group-item" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Status", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tag = _resolveComponent("Tag")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("small", null, _toDisplayString(_ctx.getSignedDeclarationForm.type), 1)
      ]),
      _createElementVNode("li", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("small", null, _toDisplayString(_ctx.getSignedDeclarationForm.reason), 1)
      ]),
      _createElementVNode("li", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("small", null, _toDisplayString(_ctx.getSignedDeclarationForm.source_of_funding || "---"), 1)
      ]),
      _createElementVNode("li", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("small", null, _toDisplayString(_ctx.getSignedDeclarationForm.process), 1)
      ]),
      _createElementVNode("li", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("small", null, _toDisplayString(_ctx.getSignedDeclarationForm.next_steps), 1)
      ]),
      _createElementVNode("li", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("small", null, _toDisplayString(_ctx.getSignedDeclarationForm.bid_intent === true ? "Yes" : "No"), 1)
      ]),
      _createElementVNode("li", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("small", null, _toDisplayString(_ctx.getSignedDeclarationForm.type === true ? "Yes" : "No"), 1)
      ]),
      _createElementVNode("li", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("small", null, _toDisplayString(_ctx.getSignedDeclarationForm.conflict_of_interest === true ? "Yes" : "No"), 1)
      ]),
      _createElementVNode("li", _hoisted_19, [
        _hoisted_20,
        _createElementVNode("small", null, _toDisplayString(_ctx.getSignedDeclarationForm.conflict_of_interest_certs === true
            ? "Yes"
            : "No"), 1)
      ]),
      _createElementVNode("li", _hoisted_21, [
        _hoisted_22,
        _createElementVNode("small", null, _toDisplayString(_ctx.getSignedDeclarationForm.resources_available), 1)
      ]),
      _createElementVNode("li", _hoisted_23, [
        _hoisted_24,
        (_ctx.getSignedDeclarationForm.status === 'COMPLETED')
          ? (_openBlock(), _createBlock(_component_Tag, {
              key: 0,
              value: _ctx.getSignedDeclarationForm.status,
              severity: "success",
              icon: "pi pi-check-circle"
            }, null, 8, ["value"]))
          : (_openBlock(), _createBlock(_component_Tag, {
              key: 1,
              value: _ctx.getSignedDeclarationForm.status,
              severity: "info",
              icon: "pi pi-check-refresh"
            }, null, 8, ["value"]))
      ])
    ]),
    _createVNode(_component_router_link, {
      to: "/partner/partnership-negotiation",
      class: "float-end mt-3"
    }, {
      default: _withCtx(() => [
        _createTextVNode("Do you require support in this negotiation? ")
      ]),
      _: 1
    })
  ]))
}